var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/components/sub-navigation.tsx";
// import throttle from 'lodash/throttle';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl'; // import { connect } from 'react-redux';

import { useHistory } from 'react-router-dom';
import { CardHeader, CardTitle } from './ui';
const messages = defineMessages({
  back: {
    "id": "column_back_button.label",
    "defaultMessage": "Back"
  }
});

const SubNavigation = _ref => {
  let {
    message
  } = _ref;
  const intl = useIntl();
  const history = useHistory();

  const handleBackClick = () => {
    if (window.history && window.history.length === 1) {
      history.push('/');
    } else {
      history.goBack();
    }
  };

  return /*#__PURE__*/React.createElement(CardHeader, {
    "aria-label": intl.formatMessage(messages.back),
    onBackClick: handleBackClick,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 32,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(CardTitle, {
    title: message,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 36,
      columnNumber: 7
    }
  }));
};

export default SubNavigation;